import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter, Input } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
@Component({
  selector: 'app-grade',
  templateUrl: './grade.component.html',
  styleUrls: ['./grade.component.css'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class GradeComponent implements OnInit, OnChanges {
  @Input() grade: string[] = [];
  @Output() contentChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeContent: EventEmitter<string> = new EventEmitter<string>();
  @Input() selectedGrade: any;
  customGrade: any;
  gradeControl = new FormControl('');
  grades: any;

  constructor(private projectsService: ProjectsService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedGrade']) {
      this.gradeControl.setValue(this.selectedGrade);
    }
    if (this.grades) {
      this.grades.forEach((grade) => {
        if (grade?.name === this.selectedGrade) {
          this.selectedGrade = grade;
        }
      });
    }
  }
  ngOnInit() {
    this.getProjectGrades();
  }

  onSelectionChange(grade: { id: number; name: string }) {
    this.contentChange.emit(grade.id);
    this.selectedGrade = grade.name;
  }
  getProjectGrades() {
    this.projectsService.getGrades().subscribe({
      next: (response: any) => {
        if (response.meta.code === 200 && response.meta.success) {
          const apiGrades = response.data.map((grade: any) => ({
            id: grade.id,
            name: grade.name,
          }));

          this.grades = [...apiGrades, { id: 4, name: 'Custom' }];
        }
      },
      error: (error: any) => {
        console.error('Error fetching the project grade:', error);
      },
    });
  }
}
